// Fetch + parse poses.json from a bundle base URL (e.g. "/viewer_data/<hash>"),
// as written by scripts/export_viewer.py.

import type { Poses } from "./types";

export async function loadPoses(baseUrl: string): Promise<Poses> {
  const url = `${baseUrl}/poses.json`;
  const r = await fetch(url);
  if (!r.ok) throw new Error(`fetch ${url} failed: ${r.status} ${r.statusText}`);
  return (await r.json()) as Poses;
}
